/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import Spinner from 'components/Spinner';

import { usePortfolioPage } from 'hooks/page/portfolio/usePortfolioPage';

import { ClassicPortfolioImage } from './components/ClassicPortfolioImage';

import s from './ClassicPortfolio.module.css';

const ClassicPortfolio = () => {
  const { isLoading, images } = usePortfolioPage();

  return (
    <div className={s.root}>
      <h2 className="hidden">Portfolio</h2>
      {images &&
        images.map((image) => (
          <ClassicPortfolioImage key={image.image.medium} {...image} />
        ))}
      <Spinner loading={isLoading} />
    </div>
  );
};

export { ClassicPortfolio };
